// src/components/WalletSecurity/WalletExport.jsx
// "Exportar mi llave" — lo que vuelve DEMOSTRABLE la promesa de autocustodia.
// El usuario puede sacar su llave privada cuando quiera y llevarla a otra wallet
// (MetaMask, etc.). Privy la muestra en un iframe aislado en otro dominio: ni
// Bitplify ni esta app pueden leerla. Solo aplica a wallets EMBEBIDAS (las externas
// ya las controla el usuario). Render nulo si no hay wallet embebida.
//
// Se monta solo con REACT_APP_PRIVY_APP_ID (lo decide el caller), así los hooks de
// Privy no corren sin su provider.
import React, { useState } from 'react';
import { useWallets, useExportWallet } from '@privy-io/react-auth';
import { FiDownload, FiShield, FiAlertTriangle } from 'react-icons/fi';
import './WalletExport.css';

export default function WalletExport() {
  const { wallets } = useWallets();
  const { exportWallet } = useExportWallet();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  // Solo wallets embebidas de Privy se pueden exportar; las externas ya son del usuario.
  const embedded = (wallets || []).find(w => w.walletClientType === 'privy');
  if (!embedded) return null;

  const handleExport = async () => {
    setError('');
    setBusy(true);
    try {
      await exportWallet({ address: embedded.address });
    } catch (e) {
      setError(e?.message || 'No se pudo abrir el exportador. Probá de nuevo.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="wx">
      <div className="wx-head">
        <span className="wx-ic"><FiShield /></span>
        <div>
          <h3 className="wx-title">Tu llave es tuya</h3>
          <p className="wx-sub">
            Podés exportar tu llave privada cuando quieras y llevarla a otra wallet (MetaMask, etc.).
            Si Bitplify desapareciera mañana, tu plata <strong>sigue siendo tuya</strong>. Eso es autocustodia de verdad.
          </p>
        </div>
      </div>

      <button type="button" className="wx-btn" onClick={handleExport} disabled={busy}>
        <FiDownload /> {busy ? 'Abriendo…' : 'Exportar mi llave privada'}
      </button>

      {error && <div className="wx-error">{error}</div>}

      <div className="wx-warn">
        <FiAlertTriangle className="wx-warn-ic" />
        <span>
          <strong>Nunca</strong> le compartas tu llave a nadie — ni a “soporte de Bitplify”.
          La llave se muestra en una ventana segura y aislada: <strong>Bitplify nunca la ve</strong>.
          Quien tenga tu llave, tiene tu plata.
        </span>
      </div>
    </div>
  );
}
